import './product_single.scss';
import { on_ready, queue_tasks } from 'js/utils';
import Tabs from 'classes/Tabs';
import product_description_read_more from './js/description_read_more';
import product_quantity_init from './cart/quantity';
import product_options_init from './options/variation_options';

//console.log('src/woocommerce/product_single/product_single.js');

on_ready(()=>{
    queue_tasks([
        product_description_read_more,
        product_tabs_init,
        product_quantity_init,
        product_options_init,
        notify_location
    ]);
});

function product_tabs_init(){
    document.querySelectorAll('.product_custom_tabs').forEach(el=> new Tabs(el));
} 

function notify_location(){
    let form_notify_container = document.querySelector('.cwginstock-subscribe-form');
    let new_container_target = document.querySelector('.notify_back_order');

    if(!form_notify_container) return;

    new_container_target.append(form_notify_container);
    
}